export default __webpack_public_path__ + "static/media/02.794e9754.jpg";